import React from 'react'
import { CreditApplication } from '_gql'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'

import ImageWrapper from '@sputnik/components/ImageWrapper'
import StatusTile from '@sputnik/pages/Dashboard/StatusTile/StatusTile'

interface RejectedStatusTileProps {
  creditApp: CreditApplication
}

const RejectedStatusTile = ({ creditApp }: RejectedStatusTileProps) => {
  const { statusUpdatedAt } = creditApp || {}
  const [makeTestId] = useNameFormatter('RejectedStatusTile')
  return (
    <div data-testid={makeTestId('')}>
      <StatusTile
        creditApp={creditApp}
        image={
          <ImageWrapper
            alt='group of crows'
            imageName='dashboard-application-declined-status'
          />
        }
        primaryInfo={
          <FormattedMessage
            defaultMessage='We were unable to approve your application. Please check your email for additional details.'
            id='sputnik.RejectedStatusTile__lcJcUh'
          />
        }
        secondaryInfo={
          <FormattedMessage
            defaultMessage='Application declined on {date, date, long}'
            id='sputnik.RejectedStatusTile__RCppjO'
            values={{ date: new Date(statusUpdatedAt) }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Application declined'
            id='sputnik.RejectedStatusTile__Ke1K9T'
          />
        }
      />
    </div>
  )
}

export default RejectedStatusTile
